const utmTags = [
    "utm_adgroup",
    "utm_campaign",
    "utm_content",
    "utm_medium",
    "utm_source",
    "utm_term",
    "gclid",
];
export const setUtmTagsToStorage = (searchParams) => {
    const result = utmTags.reduce((acc, tag) => {
        const value = searchParams.get(tag);
        if (value) {
            acc[tag] = value;
        }
        return acc;
    }, {});
    if (Object.keys(result).length) {
        window.sessionStorage.setItem("utmTags", JSON.stringify(result));
    }
};
export const removeUtmTagsFromSearchParams = (searchParams) => {
    const path = searchParams.includes("?")
        ? searchParams.split("?")[0]
        : searchParams;
    const queryString = searchParams.includes("?")
        ? searchParams.split("?")[1]
        : "";
    const urlSearchParams = new URLSearchParams(queryString);
    utmTags.forEach((tag) => {
        urlSearchParams.delete(tag);
    });
    return urlSearchParams.toString()
        ? `${path}?${urlSearchParams.toString()}`
        : path;
};
//# sourceMappingURL=utmTags.js.map